import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, Input, Button, message, DatePicker, Checkbox } from 'antd';

import MUTATION from '../graphql/mutations/storeCustomerManagementPersonMutation.graphql';
import STORE_QUERY from '../graphql/queries/getCustomerManagementPersonsQuery.graphql';
import validationRegex from '../utils/validationRegex';

const FormItem = Form.Item;
const { TextArea } = Input;

class CustomerManagementPersonForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, { street_address, ...values }) => {
      const { customer_id } = this.props;
      if (!err) {
        this.props.mutate({
          variables: { customer_id, ...values, street_address: street_address.replace(/\r?\n|\r/g, ' ') },
          update: (cache, { data: { newCustomerManagementPerson } }) => {
            const data = cache.readQuery({
              query: STORE_QUERY,
              variables: { customer_id },
            });
            if (!Array.isArray(data.managementPersons)) data.managementPersons = [];
            data.managementPersons.push(newCustomerManagementPerson);
            cache.writeQuery({ query: STORE_QUERY, variables: { customer_id }, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical" className="bank-form">
        <FormItem
          hasFeedback
          label="First Name"
        >
          {
            getFieldDecorator(
              'first_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Middle Name"
        >
          {
            getFieldDecorator(
              'middle_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Last Name"
        >
          {
            getFieldDecorator(
              'last_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Father's First Name"
        >
          {
            getFieldDecorator(
              'father_first_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Father's Middle Name"
        >
          {
            getFieldDecorator(
              'father_middle_name',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect format!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Father's Last Name"
        >
          {
            getFieldDecorator(
              'father_last_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Designation"
        >
          {
            getFieldDecorator(
              'designation',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          label="Date of birth"
        >
          {
            getFieldDecorator(
              'dob',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<DatePicker />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="PAN no."
        >
          {
            getFieldDecorator(
              'pan_no',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.pan_no,
                    message: 'Incorrect PAN!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Aadhaar no."
        >
          {
            getFieldDecorator(
              'aadhaar_no',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.aadhaar_no,
                    message: 'Incorrect Aadhaar!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          label="Street address"
        >
          {
            getFieldDecorator(
              'street_address',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<TextArea rows={4} />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="City"
        >
          {
            getFieldDecorator(
              'city',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="State"
        >
          {
            getFieldDecorator(
              'state',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Pincode"
        >
          {
            getFieldDecorator(
              'pincode',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.pincode,
                    message: 'Pincode incorrect!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Networth"
        >
          {
            getFieldDecorator(
              'networth',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="DIN"
        >
          {
            getFieldDecorator(
              'din',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="DPIN"
        >
          {
            getFieldDecorator(
              'dpin',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          label="Is Guarantor?"
        >
          {
            getFieldDecorator('is_guarantor', {
              initialValue: false,
              valuePropName: 'checked',
            })(<Checkbox>Select if he/she is a guarantor</Checkbox>)
          }
        </FormItem>
        <FormItem
          label="Is Shareholder?"
        >
          {
            getFieldDecorator('is_shareholder', {
              initialValue: false,
              valuePropName: 'checked',
            })(<Checkbox>Select if he/she is a shareholder</Checkbox>)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Share (%)"
        >
          {
            getFieldDecorator(
              'percent_share',
              {
                rules: [
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem className="form-item-block">
          <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

CustomerManagementPersonForm.propTypes = {
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  customer_id: PropTypes.string.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(CustomerManagementPersonForm);



// WEBPACK FOOTER //
// ./src/forms/CustomerManagementPersonForm.jsx